import React, { useContext } from "react";
import { css } from "emotion";
import { colors, textSizes } from "../styles/theme";
import { GlobalContext } from "../context/GlobalState";

const InfoTitle = ({ title, hideWorkspaceName = false }) => {
  const { currentWorkspace } = useContext(GlobalContext);

  return (
    <div className={container}>
      {!hideWorkspaceName &&
        <p>{currentWorkspace && currentWorkspace.name.toUpperCase()}</p>
      }
      <h3>{title}</h3>
    </div>
  );
};

export default InfoTitle;

const container = css`
  p {
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
    letter-spacing: 1px;
  }
  h3 {
    font-size: ${textSizes.title};
  }
  margin-bottom: 10px;
`;
